import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import Menu from "./Menu";
import StudentMenu from './StudentMenu';
import Login from "../Authentication/login";
import { useHistory } from "react-router-dom";
import HomePage from "../university/LandingPage/HomePage";

const Layout = ({ props = {} }) => {
  const history = useHistory();
  const state = useSelector((state) => state) || {};
  const {
    authenticationReducer: {
      login: isLoginSuccess,
      isSuperAdmin,
      isDefaultPassword,
      passwordResetSuccess,
      studentProfile: {isStudent} = {}
    } = {},
  } = state;

  const renderContent = () => {
    if (isLoginSuccess && (!isDefaultPassword || (isDefaultPassword && passwordResetSuccess)) && !isStudent) {
      return (
        <div id="main_content">
          <Menu {...props} history={history} isSuperAdmin={isSuperAdmin} />
        </div>
      );
    } else if (isStudent) {
      return (
        <div id="main_content">
          <StudentMenu {...props} history={history} isSuperAdmin={isSuperAdmin} isStudent />
        </div>
      );
    } else {
      // return <Login history={history} />;
      return <HomePage history={history} />;
    }
  };

  return <Fragment>{renderContent()}</Fragment>;
};

export default Layout;
